import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { TemplatesAPI } from 'data/templates/api';
import { logger } from 'services';
import {
  FetchDocumentTemplateAction,
  fetchDocumentTemplateAction,
} from '../actions';
import {
  fetchDocumentTemplateStart,
  fetchDocumentTemplateStartSuccess,
} from '../slices';
import { DocumentTemplate } from '../types';

function* fetchdocumentTemplateSaga(
  action: StoreActionProps<FetchDocumentTemplateAction>,
) {
  try {
    const {
      payload: { templateId },
    } = action;

    yield put(fetchDocumentTemplateStart({ templateId }));

    const template: DocumentTemplate =
      yield TemplatesAPI.getById<DocumentTemplate>(templateId);

    yield put(fetchDocumentTemplateStartSuccess(template));
  } catch (error) {
    logger.error('an error fetching the document', { error });

    message.error('There was an error fetching the document');
  }
}

export function* watchFetchDocumentTemplateSaga(): Generator {
  yield takeLatest(fetchDocumentTemplateAction.type, fetchdocumentTemplateSaga);
}
